import React, { Component } from 'react';
import moment from "moment";
import numeral from 'numeral';
import { connect } from 'react-redux';
import {List, Map} from "immutable";
import {Icon} from "@blueprintjs/core";
import _ from "lodash";
import {isFloat} from 'validator';

// Components
import Select from "../../../components/common/virtualized-select";
import IssueLinesTable from "../../../components/common/IssueLinesTable";
import DateInput from "../../../components/common/date-input";

// Actions
import {getCustomers, cleanCustomers} from "../../../actions/customers";
import {getSalesOrders, cleanSalesOrders} from "../../../actions/sales-orders";
import {getProducts, cleanProducts, getProduct} from "../../../actions/products";
import {getStockList, cleanStockList} from "../../../actions/stock";

// Numeral configuration
import 'numeral/locales/es-es';
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class IssueDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canNewLine: false,
            // object fields
            issue_code: '',
            document_date: moment(),
            delivery_date: moment(),
            customer: -1,
            salesOrders: List([]),
            orders: [],
            comments: '',
            margin: 0,
            // costPrices
            products: List([]),
            costPrices: List([Map({ _id: -1, price: "Selecciona un precio" })]),
            selectedCostPrice: -1,
            // preview line
            newLinePvp: 0,
            newLineDiscount: 0,
            newLineVat: 0,
            lines: List([]),
            // lines
            product: -1,
            warehouse: -1,
            commentsLine: '',
            amount: 0,
            cost_price: 0,
            sale_price: 0,
            discount: 0,
            vat: 0,
            total: 0,
            // Statistics
            issueSubtotal: numeral(0).format(),
            issueVat: numeral(0).format(),
            issueTotal: numeral(0).format(),
            // line edit index
            lineToEditIndex: -1
        }
    }
    componentDidMount() {
        this.props.onRef(this);
        this.updateIssueState();
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.issue !== prevProps.issue) {
            this.updateIssueState();
        }

        // Calculate Statistics
        if (this.state.lines !== prevState.lines) {
            let issueSubtotal = 0, issueVat = 0, issueTotal = 0;

            this.state.lines.forEach(line => {
                const calcLine = this.calculateLine(line.get('amount'), line.get('cost_price'), this.state.margin, line.get('discount'), line.get('vat'));

                issueSubtotal = issueSubtotal + calcLine.subtotal;
                issueVat = issueVat + calcLine.vatLine;
                issueTotal = issueTotal + calcLine.total;
            });

            this.setState({
                issueSubtotal: numeral(issueSubtotal).format(),
                issueVat: numeral(issueVat).format(),
                issueTotal: numeral(issueTotal).format()
            });
        }

        // On Edit Mode
        if (this.props.editMode !== prevProps.editMode && this.props.editMode) {
            this.props.getCustomers({
                filters: { status: 'active' },
                projection: 'customer_code basic_info.name',
                deleteVirtuals: true
            });
            this.props.getSalesOrders({
                filters: {
                    customer: this.props.issue.getIn(['customer', '_id']),
                    $or: [{
                        status: 'partial'
                    }, {
                        status: 'sent'
                    }]
                },
                projection: 'order_code',
                deleteVirtuals: true
            });
            this.props.getProducts({
                filters: { status: 'active' },
                projection: 'product_code name',
                deleteVirtuals: true
            });
        }

            // Handle salesOrders
        if (this.props.salesOrders !== prevProps.salesOrders && this.props.salesOrders instanceof List) {
            if (!(this.props.salesOrders.get(0) && this.props.salesOrders.get(0).get('lines'))) {
                this.setState({
                    salesOrders: this.props.salesOrders
                });
            }
            else {
                let lines = List([]);
                this.props.salesOrders.forEach(order => {
                    order.get('lines').forEach(line => {
                        const calcLine = this.calculateLine(line.get('amount'), line.get('cost_price'), this.state.margin, line.get('discount'), line.get('vat'));

                        line = line.set('sale_price', calcLine.salePrice);
                        line = line.set('total', calcLine.total);
                        lines = lines.push(line);
                    });
                });
                this.setState({
                    lines,
                    product: -1,
                    warehouse: -1,
                    amount: 0,
                    price: 0,
                    discount: 0,
                    vat: 0,
                    total: 0
                }, this.validateIssue);
            }
        }

        // Handle products and costPrices
        let products = this.props.products;
        if (products !== prevProps.products) {
            if (products instanceof List) {
                if (products.size > 0) {
                    products = products.map(product => {
                        return product.set('select', `[${product.get('product_code')}] ${product.get('name')}`);
                    });
                }
                products = products.insert(0, Map({ _id: -1, select: 'Selecciona un producto' }));
                this.setState({ products });
            }
            else {
                if (products.get('cost_prices')) {
                    this.setState({
                        costPrices: products.get('cost_prices').insert(0, Map({ _id: -1, price: "Selecciona un precio" }))
                    });
                }
            }
        }

    }
    componentWillUnmount() {
        this.props.cleanProducts();
        this.props.cleanStockList();
        this.props.cleanSalesOrders();
        this.props.cleanCustomers();
        this.props.onRef(undefined);
    }

    updateIssue = () => {
        let lines = new List([]);

        this.state.lines.forEach(line => {
            lines = lines.insert(lines.size, line
                .set('product', line.getIn(['product', '_id']))
                .set('warehouse', line.getIn(['warehouse', '_id']))
                .delete('sale_price')
                .delete('total')
            );
        });

        this.props.updateIssue(this.props.issue.get('_id'), {
            // object fields
            document_date: this.state.document_date,
            delivery_date: this.state.delivery_date,
            customer: this.state.customer,
            orders: this.state.orders.map(order => order._id),
            comments: this.state.comments,
            margin: this.state.margin,
            lines
        });
    };
    updateIssueState = () => {
        this.setState({
            // object fields
            issue_code: this.props.issue.get('issue_code'),
            document_date: moment(this.props.issue.get('document_date')),
            delivery_date: moment(this.props.issue.get('delivery_date')),
            customer: this.props.issue.getIn(['customer','_id']),
            orders: this.props.issue.get('orders').toJS(),
            comments: this.props.issue.get('comments'),
            margin: this.props.issue.get('margin'),
            // costPrices
            products: List([]),
            costPrices: List([Map({ _id: -1, price: "Selecciona un precio" })]),
            selectedCostPrice: -1,
            // preview line
            newLinePvp: 0,
            newLineDiscount: 0,
            newLineVat: 0,
            lines: this.props.issue.get('lines'),
            // lines
            product: -1,
            warehouse: -1,
            commentsLine: '',
            amount: 0,
            cost_price: 0,
            sale_price: 0,
            discount: 0,
            vat: 0,
            total: 0,
            // statistics
            issueSubtotal: numeral(this.props.issue.getIn(['statistics', 'subtotal'])).format(),
            issueVat: numeral(this.props.issue.getIn(['statistics', 'vat'])).format(),
            issueTotal: numeral(this.props.issue.getIn(['statistics', 'total'])).format(),
            // line edit index
            lineToEditIndex: -1
        })
    };
    replaceLines = () => {
        const orderIds = this.state.orders.map(order => order._id);

        if (orderIds.length <= 0) {
            this.setState({
                lines: List([]),
                product: -1,
                warehouse: -1,
                amount: 0,
                price: 0,
                discount: 0,
                vat: 0,
                total: 0
            }, this.validateIssue);
        }
        else {
            this.props.getSalesOrders({
                filters: {
                    _id: { $in: orderIds }
                },
                projection: 'lines',
                populateRefs: true,
                calculateStatistics: 'issues',
                deleteVirtuals: true
            });
        }
    };
    getLineToEdit = index => {
        const line = this.state.lines.get(index);
        const calcLine = this.calculateLine(line.get('amount'), line.get('cost_price'), this.state.margin, line.get('discount'), line.get('vat'));

        window.scrollTo(0, 0);

        this.props.getProduct(line.getIn(['product', '_id']), {
            projection: '_id',
            populateRefs: true
        });
        this.props.getStockList({
            filters: {
                product: line.getIn(['product', '_id'])
            },
            projection: '-_id warehouse real_amount',
            populateRefs: true
        });

        this.setState({
            product: line.getIn(['product', '_id']),
            selectedCostPrice: -1,
            warehouse: line.getIn(['warehouse', '_id']),
            commentsLine: line.get('comments'),
            amount: line.get('amount'),
            cost_price: line.get('cost_price'),
            sale_price: calcLine.salePrice,
            discount: line.get('discount'),
            vat: line.get('vat'),
            newLinePvp: _.round(calcLine.subtotalCost, 2),
            newLineDiscount: _.round(calcLine.discountLine, 2),
            newLineVat: _.round(calcLine.vatLine, 2),
            total: calcLine.total,
            lineToEditIndex: index
        }, this.validateLine);
    };
    deleteLine = index => {
        this.setState({
            lines: this.state.lines.delete(index)
        }, this.validateIssue);
    };
    validateLine = () => {
        if (
            this.state.product !== -1 &&
            this.state.amount !== 0 &&
            this.state.warehouse !== -1
        ) {
            this.setState({ canNewLine: true });
        } else {
            this.setState({ canNewLine: false });
        }
    };
    validateIssue = () => {
        if (
            this.state.document_date.isValid() &&
            this.state.delivery_date.isValid() &&
            this.state.orders.length > 0 &&
            this.state.customer !== -1 &&
            this.state.margin !== ''
        ) {
            this.props.canSubmit(true);
        } else {
            this.props.canSubmit(false);
        }
    };
    calculateLine = (amount, costPrice, margin, discount, vat) => {
        let salePrice, subtotalCost, discountLine, subtotal, vatLine, total;
        salePrice = _.round(_.round(costPrice, 5) / (1 - (_.round(margin, 2) / 100)), 2);
        subtotalCost = _.round(amount, 5) * salePrice;
        discountLine = subtotalCost * (_.round(discount, 2) / 100);
        subtotal = subtotalCost - discountLine;
        vatLine = subtotal * (_.round(vat, 2) / 100);
        total = _.round(subtotal + vatLine, 2);

        return {
            salePrice,
            subtotalCost,
            discountLine,
            subtotal,
            vatLine,
            total
        }
    };

    render() {
        let issueDetail;

        // Form Area
        if (!this.props.editMode) {
            issueDetail = (
                <div className="panel-body" >
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label>Código de albarán de ventas *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={ this.props.issue.get('issue_code') }
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Fecha albarán *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={ moment(this.props.issue.get('document_date')).format('DD/MM/YYYY') }
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Fecha de entrega *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={ moment(this.props.issue.get('delivery_date')).format('DD/MM/YYYY') }
                                    disabled={true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ paddingBottom: 16 }} >
                        <div className="col-6">
                            <label>Cliente *</label>
                            <input
                                className="form-control"
                                type="text"
                                value={ this.props.issue.getIn(['customer', 'basic_info', 'name']) }
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row style={{ paddingBottom: 16 }}">
                        <div className="col-6">
                            <label>Pedidos de venta relacionados *</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.orders.map(order => ' ' + order.order_code)}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row" style={{ paddingBottom: 16 }} >
                        <div className="col-9">
                            <label>Comentarios</label>
                            <input
                                className="form-control"
                                type="text"
                                value={ this.props.issue.get('comments') }
                                disabled={true}
                            />
                        </div>
                        <div className="col-3">
                            <label>Margen (%) *</label>
                            <input
                                className="form-control"
                                type="text"
                                value={ this.props.issue.get('margin') }
                                disabled={true}
                            />
                        </div>
                    </div>
                    <h4>Lineas de albarán</h4>
                    <IssueLinesTable
                        issueLines={this.props.issue.get('lines')}
                    />
                    <div className="row stats-zone d-flex justify-content-end">
                        <div className="col-auto">
                            <span className="label ">{ numeral(this.props.issue.getIn(['statistics', 'subtotal'])).format() }</span>
                            <span>Subtotal</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ numeral(this.props.issue.getIn(['statistics', 'vat'])).format() }</span>
                            <span>IVA</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ numeral(this.props.issue.getIn(['statistics', 'total'])).format() }</span>
                            <span>Total</span>
                        </div>
                    </div>
                </div>
            );
        }
        else {
            issueDetail = (
                <div className="panel-body" >
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label>Código de albarán de ventas *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={ this.props.issue.get('issue_code') }
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Fecha albarán *</label>
                                <DateInput
                                    onChange={(selectedDate) => {
                                        this.setState({
                                            document_date: selectedDate
                                        }, this.validateIssue);
                                    }}
                                    value={this.state.document_date}
                                    inputWrapperStyle={{height: 40}}
                                    inputStyle={{height: 37, borderRadius: 0, border: '1px solid #ccc'}}
                                    iconStyle={{top: 9, right: 12}}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Fecha de entrega *</label>
                                <DateInput
                                    onChange={(selectedDate) => {
                                        this.setState({
                                            delivery_date: selectedDate
                                        }, this.validateIssue);
                                    }}
                                    value={this.state.delivery_date}
                                    inputWrapperStyle={{height: 40}}
                                    inputStyle={{height: 37, borderRadius: 0, border: '1px solid #ccc'}}
                                    iconStyle={{top: 9, right: 12}}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ paddingBottom: 16 }} >
                        <div className="col-6">
                            <label>Cliente *</label>
                            <Select
                                className="virtualized-select"
                                options={this.props.customers.toJS()}
                                value={this.state.customer}
                                labelKey="select"
                                valueKey="_id"
                                matchProp="select"
                                multi={false}
                                searchable={true}
                                clearable={false}
                                onChange={(customer) => {
                                    if (customer && customer._id !== this.state.customer) {
                                        if (customer._id !== -1) {
                                            this.props.getSalesOrders({
                                                filters: {
                                                    customer: customer._id,
                                                    $or: [{
                                                        status: 'partial'
                                                    }, {
                                                        status: 'sent'
                                                    }]
                                                },
                                                projection: 'order_code',
                                                deleteVirtuals: true
                                            });
                                        }
                                        this.setState({
                                            customer: customer._id,
                                            orders: []
                                        }, this.validateIssue);
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="row" style={{ paddingBottom: 16 }}>
                        <div className="col-6">
                            <label>Pedidos de venta relacionados *</label>
                            <Select
                                className="virtualized-select"
                                options={this.state.salesOrders.toJS()}
                                value={this.state.orders}
                                labelKey="order_code"
                                valueKey="_id"
                                matchProp="order_code"
                                multi={true}
                                placeholder={this.state.customer === -1 ? "Selecciona un cliente" : "Selecciona un pedido de venta"}
                                disabled={this.state.customer === -1}
                                searchable={true}
                                clearable={false}
                                removeSelected={false}
                                closeOnSelect={false}
                                onChange={(selectedValues) => this.setState({ orders: selectedValues }, this.validateIssue)}
                            />
                        </div>
                        <div className="col-6" style={{ paddingTop: 25 }}>
                            <button
                                type="button"
                                className="btn btn-custom"
                                onClick={ this.replaceLines }
                            >
                                Actualizar lineas de albarán
                            </button>
                            <Icon
                                icon="info-sign"
                                style={{ margin: '-7px 10px', color: '#000' }}
                                title="Reemplaza las lineas actuales por las lineas de los pedidos seleccionados"
                            />
                        </div>
                    </div>
                    <div className="row" style={{ paddingBottom: 16 }} >
                        <div className="col-9">
                            <label>Comentarios</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.comments}
                                onChange={ (event) => {
                                    this.setState({
                                        comments: event.target.value
                                    }, this.validateIssue);
                                }}
                            />
                        </div>
                        <div className="col-3">
                            <label>Margen (%) *</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.margin}
                                onChange={ (event) => {
                                    let margin = event.target.value;
                                    let lines = List([]);
                                    let calcLine = {};

                                    if (margin === '') margin = '0';
                                    if (margin >= 100) margin = '99';
                                    if (isFloat(margin)) {
                                        // actual lines
                                        this.state.lines.forEach(line => {
                                            calcLine = this.calculateLine(line.get('amount'), line.get('cost_price'), margin, line.get('discount'), line.get('vat'));
                                            lines = lines.push(Map({
                                                _id: line.get('_id'),
                                                product: line.get('product'),
                                                warehouse: line.get('warehouse'),
                                                comments: line.get('comments'),
                                                amount: line.get('amount'),
                                                cost_price: line.get('cost_price'),
                                                sale_price: calcLine.salePrice,
                                                discount: line.get('discount'),
                                                vat: line.get('vat'),
                                                total: calcLine.total
                                            }));
                                        });

                                        // new line
                                        calcLine = this.calculateLine(this.state.amount, this.state.cost_price, margin, this.state.discount, this.state.vat);
                                        this.setState({
                                            margin: _.round(margin, 2),
                                            sale_price: calcLine.salePrice,
                                            newLinePvp: _.round(calcLine.subtotalCost, 2),
                                            newLineDiscount: _.round(calcLine.discountLine, 2),
                                            newLineVat: _.round(calcLine.vatLine, 2),
                                            total: calcLine.total,
                                            lines
                                        }, this.validateIssue);
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <h4>Lineas de albarán { this.state.lineToEditIndex !== -1 ? <span style={{
                        paddingLeft: '50px',
                        color: '#1AB394',
                        fontStyle: 'italic',
                        fontWeight: 'bold'
                    }}>- Modo edición de línea -</span> : '' }</h4>
                    <div style={{
                        transition: 'all 0.4s',
                        margin: '0 -10px',
                        padding: '10px 10px 0',
                        ...this.state.lineToEditIndex !== -1 ? { boxShadow: '0 0 10px 1px #1AB394' } : {}
                    }}>
                        <div className="row" style={{ paddingBottom: 16 }} >
                            <div className="col-3">
                                <label>Producto *</label>
                                <Select
                                    className="virtualized-select"
                                    options={this.state.products.toJS()}
                                    value={this.state.product}
                                    labelKey="select"
                                    valueKey="_id"
                                    matchProp="select"
                                    multi={false}
                                    searchable={true}
                                    clearable={false}
                                    onChange={(product) => {
                                        if (product && product._id !== this.state.product) {
                                            if (product._id !== -1) {
                                                this.props.getProduct(product._id, {
                                                    projection: '_id',
                                                    populateRefs: true
                                                });
                                                this.props.getStockList({
                                                    filters: {
                                                        product: product._id
                                                    },
                                                    projection: '-_id warehouse real_amount',
                                                    populateRefs: true
                                                    // deleteVirtuals: true
                                                });
                                            }
                                            this.setState({
                                                product: product._id,
                                                selectedCostPrice: -1,
                                                warehouse: -1
                                            }, this.validateLine);
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-3">
                                <label>Últimos costes del producto</label>
                                <Select
                                    className="virtualized-select"
                                    options={this.state.costPrices.toJS()}
                                    value={this.state.selectedCostPrice}
                                    labelKey="price"
                                    valueKey="_id"
                                    matchProp="price"
                                    multi={false}
                                    searchable={true}
                                    clearable={false}
                                    disabled={this.state.product === -1 || this.state.costPrices.size <= 1}
                                    onChange={(selectedCostPrice) => {
                                        if (selectedCostPrice) {
                                            if (selectedCostPrice._id !== -1) {
                                                let cost_price = selectedCostPrice.price;
                                                let calcLine = {};

                                                if (cost_price === '') cost_price = '0';
                                                if (isFloat(cost_price.toString())) {
                                                    calcLine = this.calculateLine(this.state.amount, cost_price, this.state.margin, this.state.discount, this.state.vat);
                                                    this.setState({
                                                        selectedCostPrice: selectedCostPrice._id,
                                                        cost_price,
                                                        sale_price: calcLine.salePrice,
                                                        newLinePvp: _.round(calcLine.subtotalCost, 2),
                                                        newLineDiscount: _.round(calcLine.discountLine, 2),
                                                        newLineVat: _.round(calcLine.vatLine, 2),
                                                        total: calcLine.total
                                                    }, this.validateLine);
                                                }
                                            }
                                            else {
                                                this.setState({ selectedCostPrice: selectedCostPrice._id });
                                            }
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-3">
                                <label>Almacén *</label>
                                <Select
                                    className="virtualized-select"
                                    options={this.props.warehouses.toJS()}
                                    value={this.state.warehouse}
                                    labelKey="select"
                                    valueKey="_id"
                                    matchProp="select"
                                    multi={false}
                                    searchable={true}
                                    clearable={false}
                                    disabled={this.state.product === -1 || this.props.warehouses.size <= 1}
                                    onChange={(warehouse) => {
                                        if (warehouse && warehouse._id !== this.state.warehouse) {
                                            this.setState({
                                                warehouse: warehouse._id
                                            }, this.validateLine);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="row" style={{ paddingBottom: 16 }} >
                            <div className="col-12">
                                <label>Comentarios</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.commentsLine}
                                    onChange={ (event) => {

                                        this.setState({
                                            commentsLine: event.target.value
                                        });
                                    }}
                                    disabled={this.state.product === -1}
                                />
                            </div>
                        </div>
                        <div className="row" style={{ paddingBottom: 16 }} >
                            <div className="col">
                                <label>Cantidad *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.amount}
                                    onChange={ (event) => {
                                        let amount =event.target.value;
                                        let calcLine = {};

                                        if (amount === '') amount = '0';
                                        if (isFloat(amount)) {
                                            calcLine = this.calculateLine(amount, this.state.cost_price, this.state.margin, this.state.discount, this.state.vat);
                                            this.setState({
                                                amount,
                                                sale_price: calcLine.salePrice,
                                                newLinePvp: _.round(calcLine.subtotalCost, 2),
                                                newLineDiscount: _.round(calcLine.discountLine, 2),
                                                newLineVat: _.round(calcLine.vatLine, 2),
                                                total: calcLine.total
                                            }, this.validateLine);
                                        }
                                    }}
                                    disabled={this.state.product === -1}
                                />
                            </div>
                            <div className="col">
                                <label>Precio coste ud *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.cost_price}
                                    onChange={ (event) => {
                                        let cost_price = event.target.value;
                                        let calcLine = {};

                                        if (cost_price === '') cost_price = '0';
                                        if (isFloat(cost_price)) {
                                            calcLine = this.calculateLine(this.state.amount, cost_price, this.state.margin, this.state.discount, this.state.vat);
                                            this.setState({
                                                cost_price,
                                                sale_price: calcLine.salePrice,
                                                newLinePvp: _.round(calcLine.subtotalCost, 2),
                                                newLineDiscount: _.round(calcLine.discountLine, 2),
                                                newLineVat: _.round(calcLine.vatLine, 2),
                                                total: calcLine.total
                                            });
                                        }
                                    }}
                                    disabled={this.state.product === -1}
                                />
                            </div>
                            <div className="col">
                                <label>PVP ud</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.sale_price}
                                    disabled={true}
                                />
                            </div>
                            <div className="col">
                                <label>Descuento (%)</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.discount}
                                    onChange={ (event) => {
                                        let discount = event.target.value;
                                        let calcLine = {};

                                        if (discount === '') discount = '0';
                                        if (isFloat(discount)) {
                                            calcLine = this.calculateLine(this.state.amount, this.state.cost_price, this.state.margin, discount, this.state.vat);
                                            this.setState({
                                                discount,
                                                newLinePvp: _.round(calcLine.subtotalCost, 2),
                                                newLineDiscount: _.round(calcLine.discountLine, 2),
                                                newLineVat: _.round(calcLine.vatLine, 2),
                                                total: calcLine.total
                                            });
                                        }
                                    }}
                                    disabled={this.state.product === -1}
                                />
                            </div>
                            <div className="col">
                                <label>IVA (%) *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.vat}
                                    onChange={ (event) => {
                                        let vat = event.target.value;
                                        let calcLine = {};

                                        if (vat === '') vat = '0';
                                        if (isFloat(vat)) {
                                            calcLine = this.calculateLine(this.state.amount, this.state.cost_price, this.state.margin, this.state.discount, vat);
                                            this.setState({
                                                vat,
                                                newLinePvp: _.round(calcLine.subtotalCost, 2),
                                                newLineDiscount: _.round(calcLine.discountLine, 2),
                                                newLineVat: _.round(calcLine.vatLine, 2),
                                                total: calcLine.total
                                            });
                                        }
                                    }}
                                    disabled={this.state.product === -1}
                                />
                            </div>
                            <div className="col">
                                <label>PVP (€) *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.newLinePvp}
                                    disabled={true}
                                />
                            </div>
                            <div className="col">
                                <label>Descuento (€) *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.newLineDiscount}
                                    disabled={true}
                                />
                            </div>
                            <div className="col">
                                <label>IVA (€) *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.newLineVat}
                                    disabled={true}
                                />
                            </div>
                            <div className="col">
                                <label>Total (€) *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.total}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-auto" style={{ paddingTop: 23 }} >
                                { this.state.lineToEditIndex !== -1
                                    ? <button
                                        className="btn btn-primary"
                                        disabled={!this.state.canNewLine}
                                        onClick={() => {
                                            let lines = new List(this.state.lines);
                                            let index = this.state.products.findIndex( product => product.get('_id') === this.state.product );
                                            const product = this.state.products.get(index);
                                            index = this.props.warehouses.findIndex( warehouse => warehouse.get('_id') === this.state.warehouse );
                                            const warehouse = this.props.warehouses.get(index);

                                            lines = lines.set(this.state.lineToEditIndex, Map({
                                                product,
                                                warehouse,
                                                comments: this.state.commentsLine,
                                                amount: _.round(this.state.amount, 5),
                                                cost_price: _.round(this.state.cost_price, 5),
                                                sale_price: this.state.sale_price,
                                                discount: _.round(this.state.discount, 2),
                                                vat: _.round(this.state.vat, 5),
                                                total: _.round(this.state.total, 2)
                                            }));

                                            this.setState({
                                                lines,
                                                product: -1,
                                                selectedCostPrice: -1,
                                                warehouse: -1,
                                                commentsLine: '',
                                                amount: 0,
                                                cost_price: 0,
                                                sale_price: 0,
                                                vat: 0,
                                                newLinePvp: 0,
                                                newLineDiscount: 0,
                                                newLineVat: 0,
                                                discount: 0,
                                                total: 0,
                                                canNewLine: false,
                                                lineToEditIndex: -1
                                            }, this.validateIssue);
                                        }}
                                    >
                                        <Icon
                                            style={{ margin: '2px 0px' }}
                                            icon="tick" title="Guardar"
                                        />
                                    </button>
                                    : <button
                                        className="btn btn-custom"
                                        disabled={!this.state.canNewLine}
                                        onClick={() => {
                                            let lines = new List(this.state.lines);
                                            let index = this.state.products.findIndex( product => product.get('_id') === this.state.product );
                                            const product = this.state.products.get(index);
                                            index = this.props.warehouses.findIndex( warehouse => warehouse.get('_id') === this.state.warehouse );
                                            const warehouse = this.props.warehouses.get(index);

                                            lines = lines.insert(lines.size, Map({
                                                product,
                                                warehouse,
                                                comments: this.state.commentsLine,
                                                amount: _.round(this.state.amount, 5),
                                                cost_price: _.round(this.state.cost_price, 5),
                                                sale_price: this.state.sale_price,
                                                discount: _.round(this.state.discount, 2),
                                                vat: _.round(this.state.vat, 5),
                                                total: _.round(this.state.total, 2)
                                            }));

                                            this.setState({
                                                lines,
                                                product: -1,
                                                selectedCostPrice: -1,
                                                warehouse: -1,
                                                commentsLine: '',
                                                amount: 0,
                                                cost_price: 0,
                                                sale_price: 0,
                                                vat: 0,
                                                newLinePvp: 0,
                                                newLineDiscount: 0,
                                                newLineVat: 0,
                                                discount: 0,
                                                total: 0,
                                                canNewLine: false
                                            }, this.validateIssue);
                                        }}
                                    >
                                        <Icon
                                            style={{ margin: '2px 0px' }}
                                            icon="plus" title="Añadir"
                                        />
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                    <IssueLinesTable
                        editMode={true}
                        issueLines={this.state.lines}
                        deleteLine={this.deleteLine}
                        getLineToEdit={this.getLineToEdit}
                        editLineIndex={this.state.lineToEditIndex}
                    />
                    <div className="row stats-zone d-flex justify-content-end">
                        <div className="col-auto">
                            <span className="label ">{ this.state.issueSubtotal }</span>
                            <span>Subtotal</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ this.state.issueVat }</span>
                            <span>IVA</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ this.state.issueTotal }</span>
                            <span>Total</span>
                        </div>
                    </div>
                </div>
            );
        }

        return issueDetail;
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const customersReducer = state.customers;
    const salesOrdersReducer = state.salesOrders;
    const productsReducer = state.products;
    const stockReducer = state.stock;

    // Customers
    let customers = customersReducer.get('payload') || List([]);
    if (!(customers instanceof List)) customers = List([]);
    if (customers.size > 0) {
        customers = customers.map(customer => {
            return customer.set('select', `[${customer.get('customer_code')}] ${customer.getIn(['basic_info', 'name'])}`);
        });
    }
    customers = customers.insert(0, Map({ _id: -1, select: 'Selecciona un cliente' }));

    // SalesOrders
    let salesOrders = salesOrdersReducer.get('payload') || List([]);


    // Products
    const products = productsReducer.get('payload') || List([]);

    // Warehouses / Product StockList
    let warehouses = stockReducer.get('payload') || List([]);
    if (!(warehouses instanceof List)) warehouses = List([]);
    if (warehouses.size > 0) {
        warehouses = warehouses.map(warehouse => {
            return warehouse
                .set('select', `[${warehouse.getIn(['warehouse', 'warehouse_code'])}] ${warehouse.getIn(['warehouse', 'name'])} (${warehouse.get('real_amount')} uds)`)
                .set('_id', warehouse.getIn(['warehouse', '_id']))
                .set('name', warehouse.getIn(['warehouse', 'name']));
        });
    }
    warehouses = warehouses.insert(0, Map({ _id: -1, select: 'Selecciona un almacén' }));



    return {
        customers,
        salesOrders,
        products,
        warehouses
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCustomers: (query) => dispatch(getCustomers(query)),
        getSalesOrders: (query) => dispatch(getSalesOrders(query)),
        getProducts: (query) => dispatch(getProducts(query)),
        getProduct: (productId, options) => dispatch(getProduct(productId, options)),
        getStockList: (query) => dispatch(getStockList(query)),
        cleanCustomers: () => dispatch(cleanCustomers()),
        cleanSalesOrders: () => dispatch(cleanSalesOrders()),
        cleanProducts: () => dispatch(cleanProducts()),
        cleanStockList: () => dispatch(cleanStockList())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(IssueDetail);



// WEBPACK FOOTER //
// ./src/containers/sales/issues/IssueDetail.js